<template>
  <modal>
    <div class="profile">
      <div class="headshot">
        <div class="wrapper">
          <slot name="headshot" />
        </div>
      </div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
import {
  Component, Vue,
} from 'vue-facing-decorator';
import Modal from './Modal.vue';

@Component({
  name: 'Profile',
  components: { Modal },
})
export default class Profile extends Vue {

}
</script>

<style lang="scss" scoped>
  @import "../styles/utilities";

  $padding: 280px;
  $padding--mobile: 80px;

  .profile {
    display: flex;
    flex-direction: column-reverse;
    .headshot ::v-deep img {
      width: 100%;
      object-fit: cover;
    }
    .content {
      padding: $padding--mobile 6.25% 0;
      ::v-deep {
        h3 {
          @include emphasised-text;
          text-transform: none;
        }
      }
    }
    @include small {
      flex-direction: row;
      & > div {
        width: 50%;
      }
      .headshot {
        position: fixed;
        overflow: hidden;

        .wrapper {
          width: 100%;
          height: 100vh;
        }

        ::v-deep img {
          width: auto;
          min-width: 100%;
          min-height: 100vh;
          max-width: 100vw;
          display: block;
          position: absolute;
          left: -50vw;
          right: -50vw;
          margin: auto;
        }
      }
      .content {
        margin-left: 50vw;
        padding-top: $padding;
      }
    }
    @include medium {
      .headshot ::v-deep img {
        max-width: none;
        height: 100vh;
      }
      .content {
        padding: $padding 12.5% 0;
      }
    }
    @include large {
      .headshot ::v-deep img {
        height: auto;
        width: 50vw;
      }
    }
  }
</style>
